import React, { useEffect, useRef } from "react";
import { prefersReducedMotion } from "@/lib/audio";

// Real-time waveform. When `analyser` is provided and active, draws from live audio data.
// Otherwise stays as a calm minimal baseline (no fake looping).
export function Waveform({ analyser = null, active = false, bars = 32, className = "", tone = "cyan" }) {
  const ref = useRef(null);
  const reduced = prefersReducedMotion();
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const spans = el.children;
    const data = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
    let raf;
    const draw = () => {
      for (let i = 0; i < spans.length; i++) {
        let h;
        if (analyser && active && data) {
          analyser.getByteFrequencyData(data);
          const idx = Math.floor((i / spans.length) * data.length);
          const v = data[idx] / 255;
          h = 3 + v * 30;
        } else if (active && !reduced) {
          const t = Date.now() / 260;
          h = 4 + (Math.sin(t + i * 0.5) * 0.5 + 0.5) * 8;
        } else {
          h = 3 + (i % 3);
        }
        spans[i].style.height = `${h}px`;
      }
      raf = requestAnimationFrame(draw);
    };
    if (reduced && !(analyser && active)) {
      for (let i = 0; i < spans.length; i++) spans[i].style.height = `${4 + (i % 3)}px`;
    } else {
      draw();
    }
    return () => cancelAnimationFrame(raf);
  }, [analyser, active, reduced]);

  const color = tone === "cyan" ? "bg-cyan-300" : tone === "blue" ? "bg-blue-400" : tone === "violet" ? "bg-blue-400" : "bg-white";
  return (
    <div ref={ref} className={`flex items-center justify-center gap-[3px] h-10 ${className}`} aria-hidden="true">
      {Array.from({ length: bars }).map((_, i) => (
        <span key={i} className={`w-[3px] rounded-full ${color} transition-[height] duration-75`} style={{ height: 4 }} />
      ))}
    </div>
  );
}
